import type { ReactNode } from 'react';

import { ViewerAccessContext, type ViewerAccess } from './access';
import { ViewerEditLocksContext, type ViewerEditLocks } from './editLocks';

/**
 * Mounts every host contract at once, so a host root cannot forget one. Each
 * value is its own context, so a consumer re-renders only when the contract it
 * reads changes.
 * Callers should memoise each value.
 */
export const ViewerHostContractsProvider = ({
  editLocks,
  access,
  children,
}: {
  editLocks: ViewerEditLocks;
  access: ViewerAccess;
  children: ReactNode;
}) => (
  <ViewerEditLocksContext.Provider value={editLocks}>
    <ViewerAccessContext.Provider value={access}>
      {children}
    </ViewerAccessContext.Provider>
  </ViewerEditLocksContext.Provider>
);
